module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/carousel_02@2x.5678de5.jpg";